import PolicyPage from './PolicyPage'

export default PolicyPage
// eslint-disable-next-line import/export
export * from './PolicyPage'
